import { render, staticRenderFns } from "./DataTitleGroup.vue?vue&type=template&id=51fb3eec&scoped=true"
import script from "./DataTitleGroup.vue?vue&type=script&lang=js"
export * from "./DataTitleGroup.vue?vue&type=script&lang=js"
import style0 from "./DataTitleGroup.vue?vue&type=style&index=0&id=51fb3eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fb3eec",
  null
  
)

export default component.exports